export const SET_LATEST_RELEASES = 'SET_LATEST_RELEASES';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';